module.exports = __webpack_public_path__ + "img/roadmap-phase-1-cell-2-icon.35ea1a51.png";